import React from "react";
import { FixedWidth, PagesHeading } from "../../../../CommonComponents/commonStyles";
import { withRouter } from "react-router-dom";
import UserInviteForm from "./Components/UserInviteForm";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { ContentProvider, ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import Messages from "../../../../CommonComponents/Messages";

class InviteParties extends React.Component {

  constructor(props) {
    super(props);
    this.heading = {
      title: "Invite interested parties",
      cancelText: "CANCEL",
      getPageTitle: this.getPageTitle.bind(this)
    }
  }

  componentDidMount() {
    window.scroll(0, 0);
  }

  setPageTitle = (title = '') => {
    if (title) {
      this.heading.title = title;
    }
  }

  getPageTitle = () => {
    return this.heading.title;
  }

  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/"
      },
      {
        routeName: "My Account",
        path: "/my-account"
      },
      {
        routeName: () => <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="Invite interested parties" property="field_page_title" defaultMessage="Invite interested parties" />,
        path: "/my-account/invite-interested-parties"
      }
    ];
  };

  render() {
    return (
      <ContentProvider
        data-test="iip-invite-parties"
        types={[Types.SUB_HEADING_LEGACY_OPTIONS, Types.PAGE_ALERTS]}
        pages={['Invite interested parties']}>
        <FixedWidth>
          <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
          <PagesHeading data-test="iip-heading">
            <ContentMessage
              type={[Types.SUB_HEADING_LEGACY_OPTIONS]}
              page="Invite interested parties"
              property="field_page_title"
              defaultMessage="Invite interested parties"
              setTitle={this.setPageTitle} />
          </PagesHeading>
          <Messages/>
          <UserInviteForm data-test="iip-component" {...this.heading} />
        </FixedWidth>
      </ContentProvider>
    );
  }
}

export default withRouter(InviteParties);